
import { Component, Vue } from 'vue-property-decorator'
import ReviewCurriculumUnitList from '@/components/templates/ReviewCurriculumUnitList.vue'
import { ReviewBoxCurriculumUnit } from '@/models/CurriculumUnit'
import { UserReviewProblemsApi } from '@/api/methods/UserReviewProblemsApi'

/**
 * 復習BOX
 */
@Component({
  components: {
    ReviewCurriculumUnitList,
  },
})
export default class ReviewBox extends Vue {
  /** 単元情報一覧 */
  private curriculumUnitList: ReviewBoxCurriculumUnit[] = []

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    this.$loading.start()
    // クッキーから学年と教科情報を取得
    const currentSubjectCode = await this.$appCookies.studentMenuState.subjectCode.get()
    const currentGradeCode = await this.$appCookies.studentMenuState.gradeCode.get()
    // 単元一覧を取得
    const curriculumUnits = await UserReviewProblemsApi.listCurriculumUnits(currentSubjectCode, currentGradeCode)
    this.curriculumUnitList = curriculumUnits.map((curriculumUnit) => {
      return {
        id: curriculumUnit.curriculumUnitId,
        name: curriculumUnit.curriculumUnitName,
        problemCount: curriculumUnit.problemCount,
      }
    })
    this.$loading.complete()
  }

  /**
   * 単元クリック時の処理
   *
   * @param curriculumUnitId 単元ID
   */
  private onClickCurriculumUnit(curriculumUnitId: number): void {
    this.$router.push(`/student/review/${curriculumUnitId}`)
  }
}
